import { render } from "./Asteroids.vue?vue&type=template&id=68fadc2d"
import script from "./Asteroids.vue?vue&type=script&lang=js"
export * from "./Asteroids.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__